import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TheWoodsPropertiesSectionViewModel } from './the-woods-properties-section-view-model';
import { RenderContextComponent } from '../../../../../../../../models/base/render-context-component';
import type { CannabinoidOrTerpeneFromPool } from '../../../shared/card-data-with-property-pooling';
import { TheWoodsCardData } from '../../../../../../../../models/print-cards/the-woods-card-data';

@Component({
  selector: 'app-the-woods-properties-section',
  templateUrl: './the-woods-properties-section.component.html',
  styleUrl: './the-woods-properties-section.component.scss',
  providers: [TheWoodsPropertiesSectionViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TheWoodsPropertiesSectionComponent extends RenderContextComponent implements OnChanges {
  constructor(public viewModel: TheWoodsPropertiesSectionViewModel) {
    super();
  }

  @Input() propertiesBasedOnPools: CannabinoidOrTerpeneFromPool[];
  @Input() cardData: TheWoodsCardData;
  @Input() viewingInLiveView: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.propertiesBasedOnPools) this.viewModel.connectToPropertiesBasedOnPools(this.propertiesBasedOnPools);
    if (changes.cardData) this.viewModel.connectToCardData(this.cardData);
  }

  setupViews() {}
  setupBindings() {}
}
